module.exports = __webpack_public_path__ + "static/media/project-icon.f10f27ed.png";